import { FC } from 'react';
import { Modal } from '@/components/ui';
import { SuggestedItem } from '../types';

interface ContentModalProps {
  item: SuggestedItem | null;
  onClose: () => void;
}

/**
 * Content Modal for viewing suggested content details
 */
export const ContentModal: FC<ContentModalProps> = ({ item, onClose }) => {
  return (
    <Modal
      isOpen={!!item}
      onClose={onClose}
      title={item?.title}
      size="lg"
    >
      {item && (
        <div className="space-y-4">
          <p className="text-gray-700 leading-relaxed">
            {item.preview}
          </p>
          
          <div className="space-y-3 pt-4 border-t border-gray-200">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-gray-900">Forecast:</span>
              <span className="text-sm text-gray-600">
                {item.views.toLocaleString()} views · {item.clicks.toLocaleString()} clicks
              </span>
            </div>
            
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-gray-900">Template:</span>
              <span className="text-sm text-gray-600">{item.template}</span>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

